import { calcSalaryFull } from './salaryCalculator';

export function validateEmployeeSalary(employee, cfg = {}) {
  const gross = Number(employee.basic_salary ?? employee.basic);
  if (!Number.isFinite(gross) || gross <= 0) return 'Gross Monthly Salary must be a valid positive number.';
  const minimum = cfg.min_wage_enabled ? Number(cfg.min_wage) || 0 : 0;
  if (gross < minimum) return `Gross salary (₹${gross}) cannot be less than the minimum wage (₹${minimum}).`;
  for (const [field, label, max] of [
    ['custom_basic_pct', 'Custom Basic percentage', 100],
    ['custom_hra_pct', 'Custom HRA', Infinity],
    ['custom_special_allowance', 'Custom Special Allowance', Infinity],
    ['vpf_pct', 'VPF amount', Infinity], ['tds_amount', 'TDS amount', Infinity],
  ]) {
    const value = employee[field];
    if (value !== '' && value != null && (!Number.isFinite(Number(value)) || Number(value) < 0 || Number(value) > max)) {
      return `${label} must be a valid number between 0 and ${max === Infinity ? 'the available salary budget' : max}.`;
    }
  }
  for (let month = 1; month <= 12; month++) {
    const simulated = calcSalaryFull({ basic: Math.round(gross), month, year: new Date().getFullYear(), cfg: { ...cfg, ot_applicable: false }, extra: employee });
    const outsideBonus = cfg.bonus_in_gross === false ? simulated.bonus : 0;
    if (simulated.gross - outsideBonus > Math.round(gross)) return 'Salary components exceed the target gross salary. Review Basic, HRA, allowances and company salary rules.';
  }
  return '';
}

export function validateEmployeeRecord(employee, cfg = {}, today = new Date()) {
  if (!String(employee.employee_code || '').trim()) return 'Employee ID is required.';
  if (!String(employee.name || '').trim()) return 'Full Name is required.';
  if (String(employee.name).trim().length > 100) return 'Employee name cannot exceed 100 characters.';
  if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(String(employee.pan || '').trim().toUpperCase())) return 'A valid PAN Number is required.';
  if (employee.phone && !/^\d{10}$/.test(String(employee.phone))) return 'Phone number must be exactly 10 digits.';
  const parseDate = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const date = new Date(`${value}T00:00:00`);
    return Number.isFinite(date.getTime()) && date.getFullYear() === Number(value.slice(0, 4)) && date.getMonth() + 1 === Number(value.slice(5, 7)) && date.getDate() === Number(value.slice(8, 10)) ? date : null;
  };
  const dob = parseDate(employee.dob || employee.date_of_birth);
  const doj = parseDate(employee.doj || employee.date_of_joining);
  if (!dob || dob > today) return 'A valid Date of Birth is required and cannot be in the future.';
  if (!doj || doj > today) return 'A valid Date of Joining is required and cannot be in the future.';
  const eighteenth = new Date(dob); eighteenth.setFullYear(dob.getFullYear() + 18);
  const sixtieth = new Date(dob); sixtieth.setFullYear(dob.getFullYear() + 60);
  if (today < eighteenth || doj < eighteenth) return 'Employee must be at least 18 years old on joining.';
  let age = today.getFullYear() - dob.getFullYear();
  if (today.getMonth() < dob.getMonth() || (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())) age--;
  if (age > 60 || doj >= sixtieth) return 'Employee age and joining date must meet the company’s under-60 joining rule.';
  if (employee.date_of_exit) {
    const exit = parseDate(employee.date_of_exit);
    if (!exit || exit < doj) return 'Date of Exit must be a valid date on or after Date of Joining.';
  }
  return validateEmployeeSalary(employee, cfg);
}
